import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const HeroSection = () => {
  const slides = [{
    id: 1,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qsdDED6hcK3bpaqpZuX5sy/WhatsApp_Image_2025-03-20_at_10.25.59_PM.jpg',
    title: 'Luxury Living Redefined',
    description: 'Modern apartments with premium retail spaces in Virar West'
  }, {
    id: 2,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iKY8MrH4rB6iDMRTiYMMsA/WhatsApp_Image_2025-03-15_at_7.40.52_PM.jpg',
    title: 'Thoughtfully Designed Spaces',
    description: 'Spacious 2 & 3 BHK apartments with modern amenities'
  }, {
    id: 3,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6vKDemLDxmQLyjfaZxqx8k/WhatsApp_Image_2025-03-20_at_10.26.00_PM.jpg',
    title: 'Premium Retail Opportunities',
    description: 'Prime commercial spaces in a thriving location'
  }, {
    id: 4,
    image: 'https://cdn.magicpatterns.com/uploads/nRoW81Yz4fSueuXAws29hU/Screenshot_2026-03-01_102437.png',
    title: 'Typical Floor Plan',
    description: 'Proposed Redevelopment of Viral & Shantivan Society, Virar West'
  }];
  const [currentSlide, setCurrentSlide] = useState(0);
  const nextSlide = () => {
    setCurrentSlide(prev => prev === slides.length - 1 ? 0 : prev + 1);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? slides.length - 1 : prev - 1);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);
    return () => clearInterval(interval);
  }, []);
  return <section id="home" className="relative h-screen w-full overflow-hidden" data-id="element-306" data-mp="3gcs6rbul2hlo">
      {/* Slider */}
      <div className="absolute inset-0" data-id="element-307" data-mp="1zz1zjw863d7t">
        {slides.map((slide, index) => <div key={slide.id} className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`} data-id="element-308" data-mp="24xvezu70leam" data-mpi={index}>
            <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: `url(${slide.image})`
        }} data-id="element-309" data-mp="5ik3pwzf1r9x">
              <div className="absolute inset-0 bg-black opacity-40" data-id="element-310" data-mp="ph69dripxog"></div>
            </div>
          </div>)}
      </div>
      {/* Content */}
      <div className="relative h-full flex items-center" data-id="element-311" data-mp="3nxkw0uku2pbz">
        <div className="container mx-auto px-4 lg:px-8" data-id="element-312" data-mp="3ixgdkz0d7kj4">
          <div className="max-w-3xl" data-id="element-313" data-mp="3ivvjtblvk5mb">
            {slides.map((slide, index) => <div key={slide.id} className={`transition-all duration-700 ease-in-out transform ${index === currentSlide ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-314" data-mp="3dzeuwf6upn86" data-mpi={index}>
                {index === currentSlide && <>
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4" data-id="element-315" data-mp="186ghsi3anp89">
                      {slide.title}
                    </h1>
                    <p className="text-xl text-white mb-8" data-id="element-316" data-mp="2v24y7jya0yoe">
                      {slide.description}
                    </p>
                    <div className="flex flex-wrap gap-4" data-id="element-317" data-mp="2zsldzapkkwdx">
                      <a href="#projects" className="px-8 py-3 bg-blue-800 hover:bg-blue-900 text-white rounded font-medium transition-all" data-id="element-318" data-mp="2zv7kd70q55uk">
                        Explore Our Projects
                      </a>
                      <a href="#contact" className="px-8 py-3 bg-transparent border-2 border-white hover:bg-white hover:text-blue-900 text-white rounded font-medium transition-all" data-id="element-319" data-mp="2c3iuryfaevhb">
                        Schedule a Site Visit
                      </a>
                    </div>
                  </>}
              </div>)}
          </div>
        </div>
      </div>
      {/* Navigation Arrows */}
      <div className="absolute bottom-10 right-10 flex space-x-2" data-id="element-320" data-mp="3v273h23h5y4n">
        <button onClick={prevSlide} className="p-2 rounded-full bg-white/20 hover:bg-white/40 text-white transition-all" aria-label="Previous slide" data-id="element-321" data-mp="3q3vt8q99pllw">
          <ChevronLeftIcon className="h-6 w-6" data-id="element-322" data-mp="3ve320gia316" />
        </button>
        <button onClick={nextSlide} className="p-2 rounded-full bg-white/20 hover:bg-white/40 text-white transition-all" aria-label="Next slide" data-id="element-323" data-mp="3y091vnr0aha">
          <ChevronRightIcon className="h-6 w-6" data-id="element-324" data-mp="cu7u7bb2i17c" />
        </button>
      </div>
      {/* Dots */}
      <div className="absolute bottom-10 left-0 right-0" data-id="element-325" data-mp="rnb2es2rr2le">
        <div className="flex justify-center space-x-2" data-id="element-326" data-mp="mn6kqyq4k1tl">
          {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-3 h-3 rounded-full transition-all ${index === currentSlide ? 'bg-white scale-110' : 'bg-white/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-327" data-mp="10l4ufqti3a2r" data-mpi={index} />)}
        </div>
      </div>
    </section>;
};
export default HeroSection;